import type { ReactNode } from 'react';
import { CircleAlert, Database, Inbox, LoaderCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { appConfig } from '../../lib/env';

export function Spinner({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="loading-state" role="status">
      <LoaderCircle className="spin" size={26} />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      <Inbox size={30} />
      <h3>{title}</h3>
      <p>{description}</p>
      {action}
    </div>
  );
}

export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <div className="error-state" role="alert">
      <CircleAlert size={28} />
      <h3>No se pudo cargar la información</h3>
      <p>{message}</p>
      {retry ? (
        <button type="button" className="text-button" onClick={retry}>
          Reintentar
        </button>
      ) : null}
    </div>
  );
}

export function SetupRequired({ compact = false }: { compact?: boolean }) {
  if (appConfig.supabaseConfigured) return null;
  return (
    <div className={compact ? 'setup-required setup-required--compact' : 'setup-required'}>
      <Database size={28} />
      <div>
        <strong>Supabase pendiente de configurar</strong>
        <p>
          Copia <code>.env.example</code> a <code>.env.local</code> y completa la URL y la clave
          pública del proyecto.
        </p>
      </div>
      {!compact ? <Link to="/login">Ver acceso</Link> : null}
    </div>
  );
}
